import { SxProps, DialogTitle as MuiDialogTitle, styled } from '@mui/material';

import { error, primary, secondary } from 'assets/colors/colors';
import { DialogComponentProps } from './type';

export const dialogTitleStyle: SxProps = {
  padding: '0 24px',
};

const getTitleColor: Record<
  NonNullable<DialogComponentProps['variant']>,
  string
> = {
  primary: secondary.main,
  error: error.main,
  secondary: primary.main,
};

export const StyledDialogTitle = styled(MuiDialogTitle)<{
  $variant: DialogComponentProps['variant'];
}>(({ $variant }) => ({
  padding: '16px 24px',
  fontSize: '1rem',
  color: getTitleColor[$variant!],
}));
